import React from 'react'
import {Button, Typography} from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';

function SocialBtn(props) {
    const {platform, username} = props;

    const getStyles = () => {
        const baseStyles = {
            textTransform: 'none',
            borderRadius: '20px',
            padding: '0.6em',
            fontWeight: 'bold',
            color: 'white',
            display: 'flex',
            gap: 1,
            marginBottom: '0.3em',
            minWidth: { xs: 40, md: 150 },
            marginLeft: 'auto',
            '& .MuiButton-startIcon': {
                marginRight: {xs: 0, sm: 0, md: 0, lg: 0},
                marginLeft: {xs: 0, sm: 0, md: 0, lg: 0}
            },
            maxWidth: {xs: 40, md: 'unset'}
        };

        switch (platform) {
            case 'facebook':
                return { ...baseStyles, background: 'linear-gradient(135deg, #1877F2 0%, #0A66C2 100%)' };
            case 'instagram':
                return { ...baseStyles, background: 'linear-gradient(135deg, #FD5949 0%, #D6249F 50%, #285AEB 100%)' };
            default:
                return baseStyles;
        }
    };

    const getIcon = () => {
        switch (platform) {
            case 'facebook':
                return <FacebookIcon></FacebookIcon>;
            case 'instagram':
                return <InstagramIcon sx={{ marginLeft: 0}}></InstagramIcon>;
            default:
                return null;
        }
    };

    return (
        <Button
            sx={getStyles()}
            startIcon={getIcon()}
            href={`https://${platform}.com/${username}`}
            target="_blank"
        >
            <Typography variant="p" sx={{ display: {xs: 'none', sm: 'none', md: 'inline'}}}> @{username}</Typography>
        </Button>
    )
}

export default SocialBtn